/**
 * HubSpot Form Events — Registry
 *
 * Maps HubSpot form GUIDs to dataLayer event metadata. The tracker
 * (Tracker.js) looks up each submitted form's GUID here and, when found,
 * pushes a unique per-form event to dataLayer.
 *
 * This file is the marketing/paid-media editing surface — add a new form
 * entry and deploy. No tracker changes needed.
 *
 * Fields:
 *   eventName            — dataLayer event name (unique per form). Used
 *                          verbatim by the tracker — include the `hsform_`
 *                          prefix here. Matches the GTM trigger exactly.
 *   formName             — human-readable label, included in the payload.
 *   allowedFields        — strict allowlist for the `form_data` block.
 *                          Email and phone NEVER belong here; they live
 *                          in `enhanced_conversion_data` only. Omit or
 *                          leave empty to exclude `form_data` entirely.
 *   enhancedConversions  — controls the `enhanced_conversion_data`
 *                          block (email + phone for Google Ads).
 *                            true                                   → use defaults: { email: 'email', phone: 'phone' }
 *                            { phone: 'cell_phone' }                → partial override, other keys fall back to defaults
 *                            { email: 'work_email', phone: 'cell' } → full override
 *                            omitted / false                        → no EC data
 */

// Common HubSpot fields shared across most lead forms. Spread into a
// form's `allowedFields` and extend with form-specific fields.
const LEAD_BASICS = ["firstname", "lastname", "company"];

const registry = {};

/**
 * name: Marketing Center Free Trial
 * path: /marketingcentertrial/
 */
registry["f6c56597-5db9-4eec-a29b-58f937707883"] = {
  eventName: "hsform_trial_submission",
  formName: "Marketing Center Free Trial",
  allowedFields: [...LEAD_BASICS, "industry"],
  enhancedConversions: true,
};

/**
 * name: Contact Form
 * path: /marketingcentertrial/
 */
registry["b7a22474-01b5-48fb-959f-661fc9964bfd"] = {
  eventName: "hsform_ba_contact_form",
  formName: "Nearme BA Contact Form",
  allowedFields: [...LEAD_BASICS, "website", "how_did_you_hear_about_us"],
  enhancedConversions: true,
};

export default registry;
